import { Component, OnInit, Renderer2, Inject, ChangeDetectorRef, NgZone } from '@angular/core'; 
import { Router, ActivatedRoute } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms"; 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { SendCodeModel } from '@shared/security/send-code.model';
import { AppConsts } from '@shared/app-consts';
import { ValidTwoFactorProviders } from '@shared/security/valid-twofactor-providers';


/** returnUrl est une URL absolue qui peut porter une query string : elle est encodée (spec 010, E6). */
export function verifyCodeUrl(returnUrl: string): string {
  return "/login/verify-code?returnUrl=" + encodeURIComponent(returnUrl);
}

@Component({
  standalone: false,
  selector: 'app-twofactor-sendcode',
  templateUrl: './send-code.component.html',
  styleUrls: ['./send-code.component.scss'] 
})
export class TwoFactorSendCodeComponent implements OnInit  {
    selectedProvider:ValidTwoFactorProviders;
    providers:ValidTwoFactorProviders[]=[];
    sendCodeForm:FormGroup;     
    email:string;
    infoMessage:string;  
    get f() { return this.sendCodeForm.controls; }
    
    constructor(private service: AuthenticationService,
        private router: Router,
        public formBuilder: FormBuilder, 
        private changeDedectionRef :ChangeDetectorRef,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private _document,   private zone: NgZone) {
        }

        
  ngOnInit() {
      this.buildForm();
      this.initialize();
  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }

  initialize(){
      this.email = sessionStorage.getItem(AppConsts.CRMClientCurrentEmail);
      if(!this.email || this.email == null || this.email.trim() === '')
       this.router.navigate(['login']);   
      this.service.getValidTwoFactorProviders(this.email).subscribe((response:any)=>{ 
        if(response && response !=null && response.length > 0)
        {
          this.providers = response; 
          this.sendCodeForm.controls['factor'].setValue(response[0].Name);
        }
        else
        this.router.navigate(['login']);

      });
  }

 buildForm(){
    this.sendCodeForm = this.formBuilder.group({ 
        factor: ["", Validators.required]
    });
    
    this.sendCodeForm.controls['factor'].valueChanges.subscribe((value) => { 
      if(value && value != null)
      {
        const _selectedProvider = this.providers.filter(function (e) {
          return e.Name === value;
        });
          this.selectedProvider = _selectedProvider[0] as ValidTwoFactorProviders;
          if(value === "Phone")
          this.infoMessage = "Un code de sécurité va être envoyé sur votre numéro mobile "+ this.selectedProvider.ProviderValue;
          if(value === "Email")
          this.infoMessage = "Un code de sécurité va être envoyé sur votre adresse email "+ this.selectedProvider.ProviderValue;
      }
        });   
 }

 sendCode(){
     if(this.sendCodeForm.invalid)
     return; 
  let model = new SendCodeModel();
  model.SelectedProvider = this.selectedProvider.Name;
   model.Email = sessionStorage.getItem(AppConsts.CRMClientCurrentEmail);
  this.service.sendCodeTwofactor(model).subscribe((response : any)=>{
   if(response){
     sessionStorage.setItem(AppConsts.CRMClientCurrentTwoFactorProvider,this.selectedProvider.Name); 
     this.zone.runOutsideAngular(() => {
       const returnUrl =
         this.route.snapshot.queryParams["returnUrl"] || "/";
         window.location.href = verifyCodeUrl(returnUrl);
    });
   }
  });
 }
}
